define('views/modules/calendar/nutrition/nutrient/list/nutrient-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/calendar/nutrition/nutrients',
    // views
    'views/parts/list/list',
    'views/modules/calendar/nutrition/nutrient/list/nutrient-list-item',
    // templates
    'text!templates/modules/calendar/nutrition/nutrient/list/nutrient-list.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CNutrients,
    // views
    VList,
    VNutrientListItem,
    // templates
    TNutrientList
) {

    var VNutrientList = VList.extend({
        template: TNutrientList,
        item: VNutrientListItem,
        regions: {
            list: ".macro-elements",
        },
        initialize: function() {
            if (!this.collection) this.collection = new CNutrients();
            this.listenTo(this.collection, 'change', this.onCollectionChange);
        },

        getItemOptions: function(options) {

            options = _.extend({ collection: this.collection }, this.options, options);
            return options;
        },

        reset: function(nutrients, options) {
            this.collection.reset(nutrients, options);
        },

        setServing: function(serving) {
          this.options.serving = serving;
          this.render();
        },

        onCollectionChange: function() {
            this.collection._updateMacroTotal();
        },

    });

    return VNutrientList;

});

